export default {
  API_MANAGE: "/reportservice",
  API_SERVICE: "/customerservice",
  API_META: "/metadata", //元数据服务
  API_REPORT: "/report", //报表服务
  API_TT: "/ttadsservice", //TT服务
  API_AUTH: "/cyberauth",
  API_MEDIA: "/mediadata",
  API_ANALYSIS: "/analysistpl", //元数据模型
  API_WARN: "/intelligentWarning", // 智能预警
};
